import { withApplyPromoEnhancerProps } from 'viewModel/enhancedMarkdown/applyPromoEnhancer/withApplyPromoEnhancerProps';
import ApplyPromoEnhancer from 'components/EnhancedMarkdown/ApplyPromoEnhancer/ApplyPromoEnhancer';

export default withApplyPromoEnhancerProps(ApplyPromoEnhancer);
